var instance = null;

function ResourceManager() {
    if (instance !== null) {
        throw new Error("Cannot instantiate more than one ResourceManager, use ResourceManager.getInstance()");
    }
}

ResourceManager.prototype = {
    _bundles: {},

    defaultLocale: "en",
    getString: function(bundleName, resourceName, parameters, locale) {
        locale = (typeof locale === 'undefined' || locale === '')?this.defaultLocale:locale;
        var value = "missing:" + resourceName + " in " + bundleName + "_" + locale;
        if (bundleName && resourceName) {
            if (this._bundles[bundleName+"_"+locale] && (typeof this._bundles[bundleName+"_"+locale][resourceName] !== "undefined" && this._bundles[bundleName+"_"+locale][resourceName] != null)) {
                value = this._bundles[bundleName+"_"+locale][resourceName];        
            }
        }
        return value;
    }
};
ResourceManager.getInstance = function(){
    if(instance === null){
        instance = new ResourceManager();
    }
    return instance;
};

export default ResourceManager;